import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

// routes
import routes from "routes.js";

// helpers
import { getSessionCookie } from "helpers/cookies.js";

var ps;

class Indicadores extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: "black",
      activeColor: "info",
    };
    this.mainPanel = React.createRef();
    this.validaPermissaoAcesso();
  }
  componentDidMount() {
    this.setState({ routes: routes });
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      this.mainPanel.current.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }
  handleActiveClick = (color) => {
    this.setState({ activeColor: color });
  };
  handleBgClick = (color) => {
    this.setState({ backgroundColor: color });
  };

  validaPermissaoAcesso = () => {    
    let session = getSessionCookie();  
    if (session == null)    
      this.props.history.push('/auth/login');          
    if (session.expired)  
      this.props.history.push('/auth/login');          
  }

  render() {
    return (
      <div className="wrapper">
        <div ref={this.mainPanel}>
          <Switch>
            {this.state.routes != null && this.state.routes.map((prop, key) => {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            })}
          </Switch>
        </div>
      </div>
    );
  }
}

export default Indicadores;
